import React from "react";

interface ProgressCircleProps {
  progress?: number; // 0 à 1, optionnel
  color?: string;
  bgColor?: string;
  strokeWidth?: number;
  size?: number;
  transition?: boolean;
  children?: React.ReactNode; // Ajout pour contenu centré
  onClick?: () => void; // Ajout de la prop onClick
}

const ProgressCircle: React.FC<ProgressCircleProps> = ({
  progress,
  color = "#fd4013",
  bgColor = "#2e2e2e",
  strokeWidth = 7,
  size = 60,
  transition = true,
  children,
  onClick,
}) => {
  const viewBox = `0 0 ${size} ${size}`;
  const cx = size / 2;
  const cy = size / 2;
  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const offset =
    progress === undefined ? 0 : circumference - progress * circumference;
  const strokeColor = color;

  return (
    <div
      style={{
        position: "relative",
        width: size,
        height: size,
        cursor: "pointer",
      }}
      onClick={onClick}
    >
      <svg
        viewBox={viewBox}
        width={size}
        height={size}
        style={{ display: "block", position: "absolute", top: 0, left: 0 }}
        className="transform -rotate-90"
      >
        <circle
          cx={cx}
          cy={cy}
          r={radius}
          stroke={bgColor}
          strokeWidth={strokeWidth}
          fill="none"
        />
        <circle
          cx={cx}
          cy={cy}
          r={radius}
          stroke={strokeColor}
          strokeWidth={strokeWidth}
          fill="none"
          strokeDasharray={circumference}
          strokeDashoffset={offset}
          style={
            transition
              ? { transition: "stroke-dashoffset 0.5s ease, stroke 0.5s ease" }
              : {}
          }
        />
      </svg>
      {children && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pointerEvents: "none",
            zIndex: 2,
          }}
        >
          {children}
        </div>
      )}
    </div>
  );
};

export default ProgressCircle;
